import { render } from "./Done.vue?vue&type=template&id=22ce379e&scoped=true&ts=true"
import script from "./Done.vue?vue&type=script&lang=ts"
export * from "./Done.vue?vue&type=script&lang=ts"

import "./Done.vue?vue&type=style&index=0&id=22ce379e&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ce379e"]])

export default __exports__